import React from 'react';
import './style.css';
import SectionLayout from '../../CommonComponents/Layout/sectionLayout';
import SponsorOptionPageHeroText from '../../CommonComponents/SponsorOptionPageHeroText';
import useLocalization from '../../../Localization';
import CustomCollapse from '../../CommonComponents/CommonAccordian';

const SponsorInfoDetailsComponent = () => {
  const {ApplicationString} = useLocalization();
  const collapseData = [
    {
      title:
        ApplicationString[
          'sponsorInfoDetailsComponent.content.vendorShowExhibition.title'
        ],
      content:
        ApplicationString[
          'sponsorInfoDetailsComponent.content.vendorShowExhibition'
        ],
    },
    {
      title:
        ApplicationString[
          'sponsorInfoDetailsComponent.content.happyHourSponsorship.title'
        ],
      content:
        ApplicationString[
          'sponsorInfoDetailsComponent.content.happyHourSponsorship'
        ],
    },
    {
      title:
        ApplicationString[
          'sponsorInfoDetailsComponent.content.lunchSponsorship.title'
        ],
      content:
        ApplicationString[
          'sponsorInfoDetailsComponent.content.lunchSponsorship'
        ],
    },

    {
      title:
        ApplicationString[
          'sponsorInfoDetailsComponent.content.majorSponsorship.title'
        ],
      content:
        ApplicationString[
          'sponsorInfoDetailsComponent.content.majorSponsorship'
        ],
    },
    {
      title:
        ApplicationString[
          'sponsorInfoDetailsComponent.content.raffleRules.title'
        ],
      content:
        ApplicationString['sponsorInfoDetailsComponent.content.raffleRules'],
    },
     {
      title:
        ApplicationString[
          'sponsorInfoDetailsComponent.content.cancellationPolicy.title'
        ],
      content:
        ApplicationString['sponsorInfoDetailsComponent.content.cancellationPolicy'],
    },
  ];
  return (
    <>
      <SponsorOptionPageHeroText
        title={ApplicationString['sponsorInfoDetailsComponent.title']}
        subTitle={ApplicationString['pbss.generalInformation.subtitle']}
      />
      <SectionLayout>
        <div className='sponsorInfoDetails-cards-wrapper'>
          <CustomCollapse data={collapseData} titleHide />
          <div>
            {ApplicationString[
              `userSponsorshipInfo.content.raffleRules.contactUs`
            ].includes('info@pbss.org')
              ? ApplicationString[
                  `userSponsorshipInfo.content.raffleRules.contactUs`
                ]
                  .split('info@pbss.org')
                  .map((part, index, array) => (
                    <>
                      {part}
                      {index < array.length - 1 && (
                        <a href='mailto:info@pbss.org'>info@pbss.org</a>
                      )}
                    </>
                  ))
              : ''}
          </div>
        </div>
      </SectionLayout>
    </>
  );
};

export default SponsorInfoDetailsComponent;
